export const commonLabels = {
  approve: 'Approve',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  confirmDelete: 'Confirm Delete',
  confirmNavigation: 'Confirm Navigation',
  dateUnavailable: 'Date unavailable',
  delete: 'Delete',
  demandStar: 'DemandStar',
  deselect: 'Deselect',
  edit: 'Edit',
  error: 'Error',
  loading: 'Loading...',
  no: 'No',
  notFound: 'No records were found',
  ok: 'OK',
  save: 'Save',
  search: 'Search',
  select: 'Select',
  submit: 'Submit',
  upload: 'Upload',
  viewMore: 'View more',
  yes: 'Yes',
} as const;

export const commonFieldNames = {
  description: 'Description',
  documents: 'Documents',
  dueDate: 'Due Date',
  status: 'Status',
  title: 'Title',
  type: 'Type',
} as const;

export const defaultNumericId = -1;
